<template>
  <v-app id="billing-settings" style="max-width: 1200px;">
    <div class="wrap-billing-settings">
      <v-layout class="wrap xs12">
        <v-layout>
          <v-flex class="mb-4">
            <div class="billing-top-header">
              <div class="caption mb-2">
                <span 
                  @click="$router.push('/settings')"
                  class="pointer primary--text text-uppercase"
                >Settings</span>
                <span class="px-2 grey--text">/</span>
                <span 
                  class="grey--text text-uppercase"
                >Directory Listing</span>
              </div>
              <h2 class="headline">Directory Listing</h2>
            </div>
          </v-flex>
          <v-spacer></v-spacer>
          <!-- <v-menu
            v-if="showOnList && !no_data.includes(listingUrl)"
            offset-y bottom left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                elevation="0"
                v-on="on"
                small
                :disabled="false"
              ><v-icon small left>link</v-icon> Public Listing <v-icon>arrow_drop_down</v-icon></v-btn>
            </template>
            <v-list class="py-0">
              <v-list-item @click="goToPublicListing">
                <v-list-item-title>
                  <v-icon color="primary" class="mr-2">open_in_new</v-icon>
                  View in a browser
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="copyPublicListingLink">
                <v-list-item-title>
                  <v-icon color="primary" class="mr-2">content_copy</v-icon>
                  Copy the link
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
        </v-layout>
      </v-layout>
    </div>

    <v-card class="mt-6">
      <show-on-listing @done="getOrganizationSettings(true)"></show-on-listing>
      <business-name></business-name>
      <!-- <business-address @done="getOrganizationSettings(true)"></business-address> -->
      <!-- <business-phone @done="getOrganizationSettings(true)"></business-phone> -->
      <business-website @done="getOrganizationSettings(true)"></business-website>
      <!-- <brief-description @done="getOrganizationSettings(true)"></brief-description> -->
      <!-- <long-description @done="getOrganizationSettings(true)"></long-description> -->
      <!-- <google-reviews @done="getOrganizationSettings(true)"></google-reviews> -->
      <!-- <facebook-reviews @done="getOrganizationSettings(true)"></facebook-reviews> -->
      <!-- <yelp-reviews @done="getOrganizationSettings(true)"></yelp-reviews> -->
    </v-card>

    <!-- <v-lazy
      :options="{ threshold: .5 }"
      min-height="197"
      transition="fade-transition"
    >
      <images></images>
    </v-lazy> -->
    <!-- <v-lazy
      :options="{ threshold: .5 }"
      min-height="197"
      transition="fade-transition"
    >
      <callouts></callouts>
    </v-lazy> -->
    <!-- <v-lazy
      :options="{ threshold: .5 }"
      min-height="197"
      transition="fade-transition"
    >
      <faq></faq>
    </v-lazy> -->
    <!-- <v-lazy
      :options="{ threshold: .5 }"
      min-height="197"
      transition="fade-transition"
    >
      <special-offers></special-offers>
    </v-lazy> -->
    <!-- <v-lazy
      :options="{ threshold: .5 }"
      min-height="197"
      transition="fade-transition"
    >
      <guarantees></guarantees>
    </v-lazy> -->

    <!-- <v-card class="mt-6">
      <signup-form-option @done="getOrganizationSettings(true)"></signup-form-option>
    </v-card> -->

    <!-- <v-card class="mt-6">
      <commercial-services @done="getOrganizationSettings(true)"></commercial-services>
    </v-card> -->
  </v-app>
</template>

<script>
import EventBus from '@/main'
import ApiService from "@/common/api.service"
import { mapGetters, mapActions } from 'vuex'
import ShowOnListing from './ShowOnListing'
import BusinessName from './BusinessName'
import BusinessPhone from './BusinessPhone'
import BusinessWebsite from './BusinessWebsite'
import BriefDescription from './BriefDescription'
import LongDescription from './LongDescription'
import GoogleReviews from './GoogleReviews'
// import FacebookReviews from './FacebookReviews'
// import YelpReviews from './YelpReviews'
import BusinessAddress from './BusinessAddress'
import Images from './Images/Images'
import Callouts from './Callouts/Callouts'
import Faq from './Faq/Faq'
import SpecialOffers from './SpecialOffers/SpecialOffers'
import Guarantees from './Guarantees/Guarantees'
import SignupFormOption from './SignupFormOption'
import CommercialServices from './CommercialServices'

export default {
  name: "DirectoryListing",
  components: {
    ShowOnListing,
    BusinessName,
    BusinessPhone,
    BusinessWebsite,
    BriefDescription,
    LongDescription,
    GoogleReviews,
    // FacebookReviews,
    // YelpReviews,
    BusinessAddress,
    Images,
    Callouts,
    Faq,
    SpecialOffers,
    Guarantees,
    SignupFormOption,
    CommercialServices,
  },
  data() {
    return {
      no_data: [null, '', undefined, 'null'],
      loading: false,
      organization_settings: {},
      preparedData: {},
      saveLoading: false,
      serverValidation: true,
      serverValidationMessage: 'Oops something went wrong...'
    }
  },
  mounted() {
    this.getOrganizationSettings()
  },
  methods: {
    ...mapActions(['checkOrganizationSettings']),
    getOrganizationSettings(mandatory = false) {
      this.loading = true;
      return new Promise((resolve, reject) => {
      this.checkOrganizationSettings(mandatory)
        .then(response => {
          let organization_settings = {...response}
          this.organization_settings = organization_settings;
          this.preparedData = { ...this.organization_settings };
          this.loading = false;
          resolve()
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
          reject()
        });
      })
    },
    editFieldtech() {
      let body = {
        organization_settings: [
          {
            key: "rating_tipping",
            value: this.preparedData.rating_tipping
          },
          {
            key: "show_rating_comment_fieldtech",
            value: this.preparedData.show_rating_comment_fieldtech
          }
        ]
      };
      this.saveLoading = true;
      this.resetServerValidation();

      ApiService.put("/organization_settings", body)
        .then(response => {
          this.saveLoading = false;
          EventBus.$emit("notification", {
            status: "success",
            text: "Rating, Comments and Tips Settings have been successfully edited."
          });
          this.getOrganizationSettings(true);
        })
        .catch(({ response }) => {
          this.saveLoading = false;
          this.serverValidation = false;
          if (response.data.error) {
            this.serverValidationMessage = this.titleCase(response.data.error);
          }
          if (response.data.message) {
            this.serverValidationMessage = response.data.message;
          }
          if (response.data.errors) {
            if (typeof response.data.errors === "string") {
              this.serverValidationMessage = response.data.errors;
            } else {
              this.server_errors = response.data.errors;
            }
          }
        });
    },
    titleCase(str){
      return _.startCase(str.replace(/_/g, ' '));
    },
    goToPublicListing () {
      window.open(this.listingUrl, "_blank");
    },
    copyPublicListingLink () {
      try {
        navigator.clipboard.writeText(this.listingUrl)
        EventBus.$emit("notification", {
          status: "success",
          text: "Link has been successfully copied to clipboard."
        });
      } catch {
        EventBus.$emit("notification", {
          status: "error",
          text: "Oops something went wrong..."
        });
      }
    },
    resetServerValidation() {
      this.serverValidation = true
      this.serverValidationMessage = 'Oops something went wrong...'
    }
  },
  computed: {
    ...mapGetters([
      'organizationSettings',
      'listingUrl'
    ]),
    showOnList () {
      return !this.no_data.includes(this.organizationSettings) &&
        !this.no_data.includes(this.organizationSettings.show_on_list) &&
        Boolean(Number(this.organizationSettings.show_on_list))
    }
  }
}
</script>
